/* Connabis: Header (mega menú + cajón móvil) */
if (!customElements.get('connabis-header')) {
  class ConnabisHeader extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-ch-trigger]'));
      this.panels = {};
      this.querySelectorAll('[data-ch-panel]').forEach((p) => (this.panels[p.dataset.chPanel] = p));
      this.backdrop = this.querySelector('[data-ch-backdrop]');
      this.drawer = this.querySelector('[data-ch-drawer]');
      this.current = null;
      this.closeTimer = null;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.triggers.forEach((btn) => {
        const name = btn.dataset.chTrigger;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const hoverMenu = name !== 'account' && this.canHover.matches;
          if (this.current === name && !hoverMenu) this.close();
          else this.open(name);
        });
        if (name !== 'account') {
          btn.addEventListener('mouseenter', () => { if (this.canHover.matches) this.open(name); });
          btn.addEventListener('mouseleave', () => { if (this.canHover.matches) this.scheduleClose(); });
        }
      });

      Object.entries(this.panels).forEach(([name, panel]) => {
        if (name === 'account') return;
        panel.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
        panel.addEventListener('mouseleave', () => { if (this.canHover.matches) this.scheduleClose(); });
      });

      // Pestañas del mega menú de productos
      this.querySelectorAll('[data-ch-tab]').forEach((tab) => {
        const activate = () => this.activateTab(tab);
        tab.addEventListener('mouseenter', activate);
        tab.addEventListener('focus', activate);
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          const tabs = Array.from(this.querySelectorAll('[data-ch-tab]'));
          const i = tabs.indexOf(tab) + (e.key === 'ArrowDown' ? 1 : -1);
          const next = tabs[(i + tabs.length) % tabs.length];
          next.focus();
        });
      });

      if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());

      this.onDocClick = (e) => { if (this.current && !this.contains(e.target)) this.close(); };
      this.onKey = (e) => {
        if (e.key !== 'Escape') return;
        if (this.drawer && this.drawer.classList.contains('is-open')) return this.closeDrawer();
        if (this.current) {
          const t = this.querySelector(`[data-ch-trigger="${this.current}"]`);
          this.close();
          if (t) t.focus();
        }
      };
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);

      // Cajón móvil
      this.querySelectorAll('[data-ch-drawer-open]').forEach((b) => b.addEventListener('click', () => this.openDrawer()));
      this.querySelectorAll('[data-ch-drawer-close]').forEach((b) => b.addEventListener('click', () => this.closeDrawer()));

      // Reducir al hacer scroll
      this.sectionEl = this.closest('.shopify-section') || this.parentElement;
      this.hideOnScroll = this.hasAttribute('data-hide-on-scroll');
      this.lastY = window.scrollY || 0;
      this.startTop = this.sectionEl ? this.sectionEl.getBoundingClientRect().top + this.lastY : 0;
      this.onScroll = () => {
        const y = window.scrollY || document.documentElement.scrollTop;
        this.classList.toggle('is-scrolled', y > 40);
        if (!this.hideOnScroll || !this.sectionEl) return;
        const delta = y - this.lastY;
        const threshold = (this.startTop || 0) + this.offsetHeight + 60;
        if (y <= threshold) { this.revealBar(); this.lastY = y; return; }
        // Los cambios pequeños se acumulan (evita parpadeos por el encogimiento del header)
        if (delta > 8) { if (!this.isBusy()) this.hideBar(); this.lastY = y; }
        else if (delta < -24) { this.revealBar(); this.lastY = y; }
      };
      // Mostrar el header cuando aparece la notificación del carrito
      const note = this.querySelector('cart-notification, #cart-notification, .cart-notification');
      if (note && window.MutationObserver) {
        new MutationObserver(() => { if (note.querySelector('.active') || note.classList.contains('active')) this.revealBar(); })
          .observe(note, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }
      this.addEventListener('focusin', () => this.revealBar());
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();

      // Editor de temas: mostrar el bloque seleccionado
      document.addEventListener('shopify:block:select', (e) => {
        if (!this.contains(e.target)) return;
        const tab = e.target.closest('[data-ch-tab]');
        if (tab) { this.open('products'); this.activateTab(tab); }
        else if (e.target.closest('[data-ch-panel="learn"]')) this.open('learn');
      });
      document.addEventListener('shopify:block:deselect', () => this.close());
    }

    isBusy() {
      if (this.current) return true;
      if (this.drawer && this.drawer.classList.contains('is-open')) return true;
      const openDetails = Array.from(this.querySelectorAll('details[open]')).filter((d) => !(this.drawer && this.drawer.contains(d)));
      if (openDetails.length) return true;
      return false;
    }

    hideBar() { if (this.sectionEl) this.sectionEl.classList.add('ch-is-hidden'); }

    revealBar() { if (this.sectionEl) this.sectionEl.classList.remove('ch-is-hidden'); }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('scroll', this.onScroll);
    }

    activateTab(tab) {
      const id = tab.dataset.chTab;
      this.querySelectorAll('[data-ch-tab]').forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.querySelectorAll('[data-ch-tabpanel]').forEach((p) => p.classList.toggle('is-active', p.dataset.chTabpanel === id));
    }

    open(name) {
      clearTimeout(this.closeTimer);
      if (this.current === name) return;
      Object.entries(this.panels).forEach(([n, p]) => { p.hidden = n !== name; });
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', t.dataset.chTrigger === name ? 'true' : 'false'));
      if (this.backdrop) this.backdrop.hidden = name === 'account';
      this.current = name;
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(), 180);
    }

    close() {
      clearTimeout(this.closeTimer);
      Object.values(this.panels).forEach((p) => (p.hidden = true));
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
      if (this.backdrop) this.backdrop.hidden = true;
      this.current = null;
    }

    openDrawer() {
      if (!this.drawer) return;
      this.close();
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      const b = this.querySelector('[data-ch-drawer-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const c = this.drawer.querySelector('button[data-ch-drawer-close]');
      if (c) setTimeout(() => c.focus(), 50);
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      const b = this.querySelector('[data-ch-drawer-open]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
      document.body.style.overflow = '';
    }
  }
  customElements.define('connabis-header', ConnabisHeader);
}
